import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const config = {
  apiKey: 'AIzaSyDKvkJQPofED1QI2uu9r8vnu0xC2ANOAZM',
  authDomain: 'memorycards-game.firebaseapp.com',
  databaseURL: 'https://memorycards-game-default-rtdb.firebaseio.com',
  projectId: 'memorycards-game',
  storageBucket: 'memorycards-game.appspot.com',
  messagingSenderId: '816819449029',
  appId: '1:816819449029:web:ec90495ab669ba2d6f14ac'
}

const app = initializeApp(config)
const database = getDatabase(app)

export {
  app,
  database
}
